export default __webpack_public_path__ + "static/media/bse-payment-640.3afad53a.svg";